module.exports = __webpack_public_path__ + "media/src/images/icons/paper-plane-9a131297b2b4bd8de930da877b1258ad.svg";